import { resolveTaskType } from 'pages/Classroom/utils/taskTypeResolver'

/**
 * Determine assignment type from assignment object.
 * Priority: explicit type (except General) -> title-based detection.
 */
export const getAssignmentType = assignment => {
	if (!assignment) return null

	const assignmentData = assignment.assignmentData || assignment.data || {}
	return (
		resolveTaskType({
			type: assignment.type || assignmentData.type,
			title:
				assignment.title ||
				assignment.name ||
				assignment.task_title ||
				assignmentData.title,
			fallback: null,
		}) || null
	)
}
